import { styled, css } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import { createTransition } from '../utilities/create-transition.js';
import { createElement, Fragment } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { Spring } from 'react-spring/renderprops.cjs';
import ProgressIndicatorWrapper$1 from './ProgressIndicatorProgress.js';

const ProgressIndicatorWrapper = styled(Div)`
  display: flex;
  position: relative;
  ${({
  theme
}) => css`
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeBase};
    font-weight: ${theme.typography.fontWeightRegular};
    line-height: ${theme.typography.lineHeightBase};
  `};
`;

const _excluded = ["disabled", "opacity", "radius", "theme"];
const ProgressIndicatorCircle = styled(Div).attrs(_ref => {
  let {
      disabled,
      opacity,
      radius,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: 'calc(100% - 20px)',
    height: 'calc(100% - 20px)',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
    opacity,
    color: disabled ? theme.palette.action.disabledBackground : theme.palette.text.primary,
    border: `1px solid
      ${disabled ? theme.palette.action.disabledBackground : theme.palette.success.main}`,
    fontSize: `${radius / 2}px`,
    transition: createTransition(['width', 'height', 'color'], {
      duration: 'standard',
      easing: 'easeInOut'
    })
  }, props);
})``;

function ProgressIndicator({
  value = 100,
  stroke = 3,
  content = true,
  intermediateMode = false,
  intermediateTimeMs = 3000,
  disabled,
  from,
  radius,
  size,
  children,
  styles = {},
  props = {}
}) {
  let r = radius || 0;
  const currentValue = value >= 100 ? 100 : value;
  if (!radius && !size) {
    size = 'medium';
  }
  switch (size) {
    case 'small':
      r = 30;
      break;
    case 'medium':
      r = 45;
      break;
    case 'large':
      r = 65;
      break;
    default:
      r = radius || 45;
  }
  return /*#__PURE__*/createElement(Spring, {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    config: {
      duration: 750
    }
  }, ({
    opacity
  }) => /*#__PURE__*/createElement(ProgressIndicatorWrapper, _extends({
    width: `${r * 2}px`
  }, styles.root, {
    testId: "progress-wrapper"
  }), /*#__PURE__*/createElement(Spring, {
    immediate: disabled,
    from: {
      value: from || 0
    },
    to: {
      value: currentValue
    },
    delay: 250
  }, ({
    value: springValue
  }) => /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ProgressIndicatorWrapper$1, {
    disabled: disabled,
    radius: r,
    stroke: stroke,
    value: springValue,
    size: size,
    intermediateMode: intermediateMode,
    intermediateTimeMs: intermediateTimeMs,
    opacity: opacity,
    props: props
  }), /*#__PURE__*/createElement(ProgressIndicatorCircle, _extends({
    disabled: disabled,
    radius: r,
    opacity: opacity,
    testId: "progress-inner-circle"
  }, styles.indicator), children, !children && content ? `${springValue.toFixed(0)}%` : '')))));
}

export default ProgressIndicator;
